import {
  createMarkdownCard,
  createSectionedHorizontalCard,
} from '@/lib/idea-card-factory';
import type { IdeaCardInputData } from '@/lib/idea-card-types';

export const PARSED_IDEA_CARD_TITLE_LIMIT = 80;

export const truncateParsedIdeaCardTitle = (title: string): string =>
  title.length > PARSED_IDEA_CARD_TITLE_LIMIT
    ? `${title.slice(0, PARSED_IDEA_CARD_TITLE_LIMIT - 3)}...`
    : title;

export const deriveFallbackMarkdownCardParts = (value: string): { title: string; body?: string } => {
  const trimmed = value.trim();
  const firstSentenceEnd = trimmed.search(/[.!?]/);
  const rawTitle =
    firstSentenceEnd > 0
      ? trimmed.slice(0, firstSentenceEnd + 1)
      : trimmed;
  const title = truncateParsedIdeaCardTitle(rawTitle || trimmed);
  const body = trimmed.slice(rawTitle.length).trim();

  return {
    title: title || truncateParsedIdeaCardTitle(trimmed),
    body: body || undefined,
  };
};

export const createFinalMarkdownCard = (
  input: Parameters<typeof createMarkdownCard>[0]
): ReturnType<typeof createMarkdownCard> =>
  createMarkdownCard({
    ...input,
    title: truncateParsedIdeaCardTitle(input.title),
  });

export const createFinalSectionedHorizontalCard = (
  input: Parameters<typeof createSectionedHorizontalCard>[0]
): ReturnType<typeof createSectionedHorizontalCard> =>
  createSectionedHorizontalCard({
    ...input,
    title: truncateParsedIdeaCardTitle(input.title),
  });

export const finalizeParsedIdeaCard = (card: IdeaCardInputData): IdeaCardInputData =>
  card.bodyModel === 'sectioned_horizontal'
    ? createFinalSectionedHorizontalCard(card)
    : createFinalMarkdownCard(card);
